import ready from 'utils/ready';
import loadScript from 'utils/load-script';

ready(() => {
  const init = async () => {
    await loadScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
  };

  const observation = () => {
    const widgets: NodeListOf<HTMLElement> = document.body.querySelectorAll('.trustpilot-widget');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          init();
          observer.disconnect();
        }
      });
    });

    widgets.forEach((widget) => {
      observer.observe(widget);
    });
  };

  observation();
});
